const granCenter = [
  { id: 1, description: 'Puerto' },
  { id: 2, description: 'Acopio Receptor' },
  { id: 3, description: 'Operatoria Acopio' }
];

export default granCenter;
